import { merge as lodashMerge, isPlainObject, isEmpty } from "lodash";
export const configMerge = (...args) => {
    const lastArg = args[args.length - 1];
    if (!isPlainObject(lastArg))
        return lastArg;
    return lodashMerge({}, ...args);
};
export const localiseForLocale = (config, locale) => Object.fromEntries(Object.entries(config).map(([key, value]) => {
    if (!isPlainObject(value))
        return [key, value];
    if (value?.localised) {
        const { localised, ...defaults } = value;
        if (locale && localised[locale])
            return [key, localiseForLocale(configMerge(defaults, localised[locale]), locale)];
        return [key, isEmpty(defaults) ? undefined : localiseForLocale(defaults, locale)];
    }
    return [key, localiseForLocale(value, locale)];
}));
